import styled from 'styled-components'

const HeaderIconContainer = styled.span<{ $background?: string }>`
  width: 38px;
  height: 38px;
  border-radius: 6px;
  background: ${({ $background }) => $background ?? 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export default HeaderIconContainer
